export function fmtCurrency(n: number): string {
  const abs = Math.abs(Math.round(n))
  const value = abs >= 1_000_000 ? '$' + (abs / 1_000_000).toFixed(2) + 'M' : '$' + abs.toLocaleString('en-US')
  return n < 0 ? '-' + value : value
}

export function fmtFullCurrency(n: number): string {
  return '$' + Math.round(Math.abs(n)).toLocaleString('en-US')
}

export function parseCurrency(s: string): number {
  const parsed = parseInt(s.replace(/[^0-9]/g, ''), 10)
  return isNaN(parsed) ? 0 : Math.min(parsed, 99_999_999)
}
